/** Shared i18n keys for labels consolidated under common.* */
export const COMMON_LABEL_FALLBACKS: Record<string, string> = {
  country: 'common.country',
  organisation: 'common.entity',
  entity: 'common.entity',
  name: 'common.name',
  contactName: 'common.name',
  description: 'common.description',
  currency: 'common.currency',
  review: 'common.review',
  active: 'common.active',
  error: 'common.error',
  apply: 'common.apply',
  clear: 'common.clear',
  reconnect: 'common.reconnect',
  proceed: 'common.proceed',
  unknown: 'common.unknown',
};

export function getCommonLabelFallbackKey(filterKey: string): string | undefined {
  const baseKey = filterKey.split('.').pop() ?? filterKey;
  return COMMON_LABEL_FALLBACKS[baseKey] ?? COMMON_LABEL_FALLBACKS[filterKey];
}
